export const exportHeaders = [
    { 
        label: "Member ID", 
        key:"loyalty_id" 
    },
    {
        label: "Billing Account Number",
        key: "customer_billto_account_number",
    },
    { 
        label: "Enrollment / Transfer", 
        key: "member_account_created_by" 
    },
    { 
        label: "Account Created By", 
        key: "request_by" 
    },
    { 
        label: "Status", 
        key: "is_active" 
    },
    { 
        label: "Unconsented Days", 
        key: "unconsented_days"
    },
    { 
        label: "Extended Date", 
        key: "deactive_extended_date"
    },
]